"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentStruct = exports.AppointmentShortStruct = exports.ContactDataStruct = exports.AppointmentCommentStruct = exports.AppointmentCommentAuthorStruct = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
const formData_1 = require("./formData");
const locale_1 = require("./locale");
const order_1 = require("./order");
exports.AppointmentCommentAuthorStruct = (0, superstruct_1.type)({
    firstName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    lastName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    email: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    counterName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
/**
 * Describes comments to an appointment
 */
exports.AppointmentCommentStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    createdAt: utils_1.TimestampStruct,
    text: (0, superstruct_1.string)(),
    author: (0, superstruct_1.optional)(exports.AppointmentCommentAuthorStruct),
});
/**
 * Constact data for an appointment
 */
exports.ContactDataStruct = (0, superstruct_1.type)({
    email: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    phone: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    firstName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    lastName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    numberOfVisitors: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    whatsAppConsent: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    pushToken: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
/**
 * Appointment without user data. Used in monitor App
 */
exports.AppointmentShortStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    placeId: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    serviceId: (0, superstruct_1.string)(),
    serviceName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    serviceColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    queueId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    scheduleId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    placeName: (0, superstruct_1.string)(),
    startTime: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    endTime: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    tag: (0, superstruct_1.string)(),
    type: (0, superstruct_1.optional)((0, superstruct_1.enums)(['appointment', 'walkin'])),
    counter: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    createdAt: utils_1.TimestampStruct,
    rejectionReason: (0, superstruct_1.optional)((0, superstruct_1.enums)(['noShow', 'lateShow', 'incomplete', 'missingStaff', 'overbooking'])),
    statusChangeReason: (0, superstruct_1.optional)((0, superstruct_1.enums)([
        'noShow',
        'lateShow',
        'incomplete',
        'missingStaff',
        'overbooking',
        'technicalIssues',
        'bulkCancelled',
    ])),
    confirmationAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    confirmation: (0, superstruct_1.enums)(['confirmed', 'pending', 'rejected']),
    status: (0, superstruct_1.enums)([
        'created',
        'invited',
        'queued',
        'processed',
        'cancelled',
        'rejected',
        'confirmed',
    ]),
    positionInQueue: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    estimatedWaitingTimeSec: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    invitedAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    queuedAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    processedAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    cancelledAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    rejectedAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    expiresAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    publicFormData: (0, superstruct_1.optional)(formData_1.FormDataStruct),
});
/**
 * Full appointment with user data
 */
exports.AppointmentStruct = (0, superstruct_1.assign)(exports.AppointmentShortStruct, (0, superstruct_1.type)({
    userId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    order: (0, superstruct_1.optional)(order_1.OrderStruct),
    formData: (0, superstruct_1.optional)(formData_1.FormDataStruct),
    createdFrom: (0, superstruct_1.enums)(['visitor', 'counter', 'kiosk']),
    preferredLanguage: (0, superstruct_1.optional)(locale_1.LocaleLongStruct),
    comments: (0, superstruct_1.optional)((0, superstruct_1.array)(exports.AppointmentCommentStruct)),
    contactData: exports.ContactDataStruct,
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    kioskCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    unreadCounterMessages: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.number)()), 0),
    lastCounterMessageAt: (0, superstruct_1.optional)(utils_1.TimestampStruct), // used for chat notification throttling
}));
exports.AppointmentStruct.type = 'Appointment';
exports.AppointmentShortStruct.type = 'AppointmentShort';
exports.AppointmentCommentStruct.type = 'AppointmentComment';
exports.ContactDataStruct.type = 'ContactData';
//# sourceMappingURL=appointment.js.map